import {
  SUGGESTED_FILTERS_CONSOLIDATION_BUCKET_CONFIGS,
  SUGGESTED_FILTERS_CONSOLIDATION_EXPERIMENT
} from '~/constants/srp/suggestedFiltersConsolidation';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import useExperimentBucket from '~/hooks/common/experiments/useExperimentBucket';
import type { SuggestedFilterTreatment } from '~/utilities/srp/suggestedFilterRange';

type SuggestedFiltersConsolidationExperimentResult = {
  isSplit: boolean;
  shouldConsolidate: boolean;
  treatment: SuggestedFilterTreatment;
};

export default function useSuggestedFiltersConsolidationExperiment(): SuggestedFiltersConsolidationExperimentResult {
  const bucket = useExperimentBucket(
    SUGGESTED_FILTERS_CONSOLIDATION_EXPERIMENT
  );
  const showComposerTreatment = useShowComposerTreatment();
  const treatmentConfig =
    SUGGESTED_FILTERS_CONSOLIDATION_BUCKET_CONFIGS.get(bucket);

  return {
    isSplit: treatmentConfig?.layout === 'split',
    shouldConsolidate: treatmentConfig !== undefined && !showComposerTreatment,
    treatment: treatmentConfig?.placement ?? 'limit'
  };
}
